// import { configureStore } from "@reduxjs/toolkit";
// import { apiSlice } from "./api/apiSlice";
// import authSliceReducer from "./auth/authSlice";
// import layoutSliceReducer from "./layout/layoutSlice";
// import loginSliceReducer from "./login/authSlice";
// import ecommerceSliceReducer from "./ecommerce/ecommerceSlice";
// import anagraficaReducer from "./Anagrafica/anagraficaSlice";
// import variabiliStrutturaReducer from "./VariabiliStruttura/variabiliStrutturaSlice"

// export const store = configureStore({
//   reducer: {
//     [apiSlice.reducerPath]: apiSlice.reducer,
//     auth: authSliceReducer,
//     layout: layoutSliceReducer,
//     login: loginSliceReducer,
//     ecommerce: ecommerceSliceReducer,
//     anagrafica: anagraficaReducer,
//     variabiliStruttura: variabiliStrutturaReducer,
//   },
//   devTools: process.env.NODE_ENV !== "production",
//   middleware: (getDefaultMiddlewares) =>
//     getDefaultMiddlewares().concat(apiSlice.middleware),
// });


import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import authSliceReducer from "./auth/authSlice";
import layoutSliceReducer from "./layout/layoutSlice";
import loginSliceReducer from "./login/authSlice";
import ecommerceSliceReducer from "./ecommerce/ecommerceSlice";
import anagraficaReducer from "./Anagrafica/anagraficaSlice";
import variabiliStrutturaReducer from "./VariabiliStruttura/variabiliStrutturaSlice";

// 1. Funzione per caricare dal localStorage
function loadFromLocalStorage() {
  try {
    const serializedState = localStorage.getItem("reduxState");
    if (serializedState === null) {
      // se non c'è nulla in localStorage, ritorniamo `undefined` così Redux usa lo state di default
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.warn("Errore durante il caricamento da localStorage:", error);
    return undefined;
  }
}

// 2. Funzione per salvare sul localStorage
function saveToLocalStorage(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("reduxState", serializedState);
  } catch (error) {
    console.warn("Errore durante il salvataggio su localStorage:", error);
  }
}

// Carichiamo eventuale stato presente sul localStorage
const persistedState = loadFromLocalStorage();

// Creiamo lo store con lo stato pre-caricato
export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authSliceReducer,
    layout: layoutSliceReducer,
    login: loginSliceReducer,
    ecommerce: ecommerceSliceReducer,
    anagrafica: anagraficaReducer,
    variabiliStruttura: variabiliStrutturaReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(apiSlice.middleware),
  // Passiamo lo stato precaricato (se presente in localStorage)
  preloadedState: persistedState,
});

// 3. Ogni volta che lo stato viene aggiornato, salviamo
store.subscribe(() => {
  const state = store.getState();
  // Puoi decidere di salvare l'intero store oppure solo alcune parti
  // ESEMPIO: salviamo solo il slice 'anagrafica'
  saveToLocalStorage({
    anagrafica: state.anagrafica,
  });
});
